import { Injectable } from '@angular/core';
import { BaseControl, Textbox, EmpresaPredeterminada, Legend, Container, TextArea } from '@app/shared';
import { Validators } from '@angular/forms';
import { find } from 'lodash';

@Injectable()
export class BusinessManagementFormService {

  constructor() { }

  /**
   * Construye y retorna el formulario para modificar la empresa
   *
   * @param {*} [empresa]
   * @returns {BaseControl<any>[]}
   * @memberof BusinessManagementFormService
   */
  getFormEmpresa(empresa?: EmpresaPredeterminada): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'nombre',
        value: empresa ? empresa.nombre ? empresa.nombre : null : null,
        label: 'Nombre',
        placeholder: 'Nombre de la empresa',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),

      new Textbox({
        key: 'descripcion',
        value: empresa ? empresa.descripcion ? empresa.descripcion : null : null,
        label: 'Descripción',
        placeholder: 'Descripción de la empresa',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),

      new Textbox({
        key: 'pagina_web',
        value: empresa ? empresa.web_page ? empresa.web_page : null : null,
        label: 'Página web',
        placeholder: 'Página web de la empresa',
        order: 3
      }),

      new Textbox({
        key: 'logo',
        value: empresa ? empresa.logo ? empresa.logo : null : null,
        label: 'Logo',
        placeholder: 'Logo de la empresa',
        order: 3,
        validations: {
          validators: [Validators.required]
        }
      }),

      new TextArea({
        key: 'mensaje',
        value: empresa ? empresa.mensaje ? empresa.mensaje : null : null,
        label: 'Mensaje',
        placeholder: 'Ingrese un breve mensaje',
        rows: '4',
        order: 4,
        validations: {
          validators: [Validators.required]
        }
      }),

      new Legend({
        value: 'Días laborales *:',
        order: 5,
        size: 'col-4',
      }),

      new Container({
        class: 'form-row form-check form-check-inline',
        order: 6,
        size: 'col-6',
        controls: [
          new Textbox({
            key: 'lunes',
            type: 'checkbox',
            label: 'Lunes',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 0) === 0 ?
                        true
                      : false
                    : false
                   : false,

          }),
          new Textbox({
            key: 'martes',
            type: 'checkbox',
            label: 'Martes',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 1) ?
                        true
                      : false
                    : false
                   : false,
          }),
          new Textbox({
            key: 'miercoles',
            type: 'checkbox',
            label: 'Miércoles',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 2) ?
                        true
                      : false
                    : false
                   : false,
          }),
          new Textbox({
            key: 'jueves',
            type: 'checkbox',
            label: 'Jueves',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 3) ?
                        true
                      : false
                    : false
                   : false,
          }),
          new Textbox({
            key: 'viernes',
            type: 'checkbox',
            label: 'Viernes',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 4) ?
                        true
                      : false
                    : false
                   : false,
          }),
          new Textbox({
            key: 'sabado',
            type: 'checkbox',
            label: 'Sábado',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 5) ?
                        true
                      : false
                    : false
                   : false,
          }),
          new Textbox({
            key: 'domingo',
            type: 'checkbox',
            label: 'Domingo',
            size: 'col-12',
            value: empresa ?
                    empresa.dias_laborales.length ?
                      find(empresa.dias_laborales, d => d === 6) ?
                        true
                      : false
                    : false
                   : false,
          })
        ]
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-system/business-management/shared/business-management-form.service.ts